import { PickerPropsType } from 'antd-mobile/lib/picker/PropsType';
import { DatePickerPropsType } from 'antd-mobile/lib/date-picker/PropsType'
import { HTMLInputProps } from 'antd-mobile/lib/input-item/Input';

export type FormItem =
  IComponentPicker |
  IComponentDatePicker |
  IComponentInput;

export enum FormItmeType {
  Input,
  Normal,
  Picker,
  DatePicker,
}

/**
 * 表单基础属性
 */
export type FormBaseProps = {
  formType: FormItmeType;
  formTitle?: string;
  formProps?: any;
  render?: any;
};

export interface IComponentPicker extends FormBaseProps, Partial<PickerPropsType> {
  placeholder?: string;
  formType: FormItmeType.Picker;
}

/**
 * 判断是否是Picker
 *
 * @export
 * @param {FormItem} data
 * @returns {data is IComponentPicker}
 */
export function isIComponentPicker(data: FormItem): data is IComponentPicker {
  return (<IComponentPicker>data).formType === FormItmeType.Picker;
}

export interface IComponentDatePicker extends FormBaseProps, Partial<DatePickerPropsType> {
  formType: FormItmeType.DatePicker;
}

/**
 * 判断是否是Picker
 *
 * @export
 * @param {FormItem} data
 * @returns {data is IComponentPicker}
 */
export function isIComponentDatePicker(data: FormItem): data is IComponentDatePicker {
  return (<IComponentDatePicker>data).formType === FormItmeType.DatePicker;
}

/**
 * 表单input组件
 *
 * @export
 * @interface IComponentInput
 * @extends {FormBaseProps}
 * @extends {HTMLInputProps}
 */
export interface IComponentInput extends FormBaseProps, HTMLInputProps {
  formType: FormItmeType.Input;
}

/**
 * 判断当前组件是否是input
 *
 * @export
 * @param {FormItem} data
 * @return {*}  {data is IComponentInput}
 */
export function isIComponentInput(data: FormItem): data is IComponentInput {
  return (<IComponentInput>data).formType === FormItmeType.Input;
}